export const NAV_HEIGHT = 60
export const GLOBAL_NAV_HEIGHT = 10
export const FOOTER_HEIGHT = 400
export const FOOTER_HEIGHT_MOBILE = 420
export const FOOTER_HEIGHT_TABLET = 500
export const PODCAST_PLAYER_HEIGHT = 66
